<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">用户邀请<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <DatePickerRange title="邀请时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
            <div class="content-input-item">
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>

            <div class="content-input-item">
              <label>性别</label>
              <el-select v-model="sex" placeholder="Select" class="select-item">
                <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>


        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
<!--            <el-button type="primary" @click="editPrizeDialog(-1)" size="default">添加项目</el-button>-->
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
              @sort-change="sortChange"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="inviteTime" label="最新邀请时间" v-if="checkColList.indexOf('最新邀请时间') > -1"/>
            <el-table-column property="" label="客户信息" v-if="checkColList.indexOf('客户信息') > -1">
              <template #default="scope">
                <UserInfo :userId="scope.row.id" :row="scope.row" showList="name,sex,phone,shopName,uid" @confirm="getPage" />
              </template>
            </el-table-column>
            <el-table-column property="inviteNum" label="邀请名单" v-if="checkColList.indexOf('邀请名单') > -1" sortable='custom' class-name="cursor">
              <template #default="scope">
                <span style="color: #3a8ee6">{{scope.row.inviteNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="awardNum" label="奖励次数" v-if="checkColList.indexOf('奖励次数') > -1" sortable='custom' class-name="cursro">
              <template #default="scope">
                <span style="color: #3a8ee6">{{scope.row.awardNum}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import { getInvitePageList} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange";
import UserInfo from "@/components/User/userInfo"
import inviteListDialog from "@/views/invite/components/inviteListDialog";
import invitePrizeDialog from "@/views/invite/components/invitePrizeDialog";

export default {
  name: "InviteUser",
  components: { BtnGroup, SearchComponents, unLock, DatePickerRange, UserInfo},
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0},
      ],
      shopIdArr:[],
      shopId: 0,


      sexArray: [
        {label: '不限', value: -1},
        {label: '未知', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2}
      ],
      sex: -1,

      //刷新组
      colList: ['最新邀请时间', '客户信息',  '邀请名单', '奖励次数'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '主人ID', value : 3},
      ],
      searchType: 1,
      searchValue: '',


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      limitState: true,

      sort: 1,

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'inviteNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'awardNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      }
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sort'] = this.sort;
      param['shopId'] = this.shopId;
      param['sex'] = this.sex;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getInvitePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      //邀请名单
      if(column.label == '邀请名单') {
        Dialog.open({
          title: '邀请名单',
          component: inviteListDialog,
          data: {
            userId: row.id,
            width: '1100px'
          },
          close: () => {

          }
        })
      }

      //邀请名单
      if(column.label == '奖励次数') {
        Dialog.open({
          title: '奖励次数',
          component: invitePrizeDialog,
          data: {
            userId: row.id,
            width: '1100px'
          },
          close: () => {

          }
        })
      }

    },

    // editPrizeDialog(idx, row) {
    //   let _title = '';
    //   let prizeForm = {}
    //   if (idx > -1) {
    //     _title = '编辑邀请奖励'
    //     prizeForm = Object.assign({}, row);
    //     // console.log(projectForm)
    //   }else {
    //     _title = '添加邀请奖励'
    //     // console.log(projectForm)
    //   }
    //   Dialog.open({
    //     title: _title,
    //     component: PrizeDialog,
    //     data: {
    //       prizeForm: prizeForm,
    //       serviceTypeList: this.serviceTypeList,
    //       ids: idx,
    //       width: '500px',
    //     },
    //     confirm: (result) => {
    //       this.getPage()
    //     }
    //   })
    // },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
